var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidMountains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3951,
    height: 843.154,
    viewBox: "0 0 3951 843.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c5e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293f52"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M204.242,445.072c90.348,0,88.125,50.53,145.357,50.53s50.056-153.16,122.126-153.16c80.9,0,70.56,50.193,131.944,50.193,64.135,0,88.351-178.754,181.191-178.342s60.668-40.45,139.174-40.45c123.2,0,152.433,452.586,233.361,452.586S1265.237,737.6,1324.669,737.6c126.435,0,152.438,189.143,247.683,189.143,53.432,0,86.822-124,173.864-124.242s108.316-125.041,185.968-125.819c71.324-.714,65.581,60.919,130.078,60.919,74.3,0,81.689-173.616,185.668-173.616s74.322-58.609,166.364-58.609c93.386-.97,42.754-305.266,217.52-305.636,129.034-.273,87.756-55.545,175.286-55.545s101.083,232.3,198.493,232.3c113.229,0,127.985,105.367,183.731,105.367,100.413,3.328,101.325-197.892,202.7-197.892,90.25,0,65.049,267.261,230.832,267.261,83.536,0,88.471,114.786,169.885,114.786S3951,737.6,3951,737.6V984.893L0,987.352S113.894,445.072,204.242,445.072Z",
    transform: "translate(0 -144.198)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidMountains);
export default __webpack_public_path__ + "static/media/mid_mountains.60737eaac3ccf8913c212a79c5e22310.svg";
export { ForwardRef as ReactComponent };